// extracted by mini-css-extract-plugin
module.exports = {"wrap":"InnovationWaveText_wrap__QyYtg","canvasContainer":"InnovationWaveText_canvasContainer__F3z6R"};